import type { api } from '@/utils/api';

/**
 * The campaign page's People tab: its table, its counts, its filter menus and the funnel above it. Anything that adds,
 * removes or moves people in a campaign (an enrollment, a candidate's status) refetches these, so the
 * People numbers and rows never lag the action. No id = every campaign's.
 */
export function invalidateCampaignPeople(utils: ReturnType<typeof api.useUtils>, cadenceTemplateId?: string) {
  const input = cadenceTemplateId == null ? undefined : { cadenceTemplateId };
  return Promise.all([
    utils.cadenceTemplate.peopleList.invalidate(input),
    utils.cadenceTemplate.peopleNumbers.invalidate(input),
    // The filter menus' counts: who replied, who can be reached — candidates included.
    utils.cadenceTemplate.peopleFilterCounts.invalidate(input),
    utils.cadenceTemplate.candidateFunnel.invalidate(input),
  ]);
}
